<template>
  <div :class="['score', { not_div: loading }]">
    <Loading v-if="loading" />
    <div class="bgc table_div">
      <div class="title">
        <div class="sort_son_title">
          {{ itemTitle }}
        </div>
        <div v-if="data && data.length" class="right_div">
          <a-button class="btn" type="primary" ghost @click="importTo">
            {{ $t('exam.downbtn') + itemTitle + $t('exam.biao') }}
          </a-button>
        </div>
      </div>
      <NotData v-show="!data.length && !loading" />
      <Table
        v-if="data && data.length"
        :columns="columns"
        :pagination="pagination"
        :data="data"
        @change="change"
      />
    </div>
  </div>
</template>

<script>
  import axios, { getCookie, getUser } from '@utils'
  import ApiXy from '@lib/api.js'
  import Table from '@comp/tables/sortTable.vue'
  import Loading from '@comp/loading'
  import { getCol } from '@utils/unite.js'
  export default {
    name: 'Studentscore',
    components: {
      Table,
      Loading
    },
    props: {
      id: {
        type: String,
        default: ''
      },
      itemTitle: {
        type: String,
        default: ''
      },
      isSet: {
        type: Boolean,
        default: true
      },
      hideRank: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        columns: [],
        schoolId: 0,
        columnsS: [
          {
            title: this.$t('exam.className'),
            dataIndex: 'stuOrgName',
            key: 'stuOrgName',
            fixed: true,
            width: 100
          },
          {
            title: this.$t('exam.name'),
            dataIndex: 'studentName',
            key: 'studentName',
            fixed: true,
            width: 100
          }
        ],
        data: [],
        pagination: {
          pageSize: 10,
          total: 0,
          showQuickJumper: true,
          showSizeChanger: true,
          hideOnSinglePage: true,
          pageSizeOptions: ['10', '20', '100', '200', '500']
        },
        orderField: 'messGradeOrder',
        orderType: 'asc',
        meIds: {},
        query: {},
        scores: [] //散点图数据
      }
    },
    watch: {
      $route: {
        handler() {
          if (this.$route.query.classId || this.$route.query.seId) {
            this.getTable(1)
          }
        },
        deep: true
      }
    },
    async mounted() {
      this.query = this.$route.query

      let {
        data: { schoolId }
      } = await getUser()

      this.schoolId = schoolId
      this.getTable(1)
    },
    methods: {
      change(pagination, filters, sorter) {
        if (sorter.field == 'className') {
          sorter.field = 'classId'
        }
        this.orderField = sorter.field
        if (sorter.order == 'descend') {
          this.orderType = 'desc'
        } else {
          this.orderType = 'asc'
        }
        this.pagination.pageSize = pagination.pageSize
        this.getTable(pagination.current)
      },
      getTable(pageIndex) {
        if (!this.isSet && this.id == 'studentcontrast') return
        this.loading = true
        // this.columns = []
        let {
          dId,
          meId,
          classId,
          seId,
          examIsActive = 1,
          bureauId,
          campusId
        } = this.$route.query
        let unionUrl = [
          'studenttranscriptlist',
          'studenttranscriptlistUnion',
          'studenttranscriptlistUnion'
        ]

        const url =
          this.id == 'studentcontrast'
            ? 'studenttranscriptcontrastlist'
            : unionUrl[examIsActive]
        // 说明是学生进退步的表

        let params = {
          dId,
          meId,
          pageSize: this.pagination.pageSize,
          pageIndex: pageIndex,
          classId: classId || 0,
          campusId,
          // orderField: this.orderField,
          // orderType: this.orderType,
          // ...this.meIds
          seId
        }
        if (url == 'studenttranscriptcontrastlist') {
          // 说明是联考的
          if (examIsActive * 1) {
            params.isUnion = 1

            // 校级联考
            if (examIsActive * 1 == 2) {
              params.bureauId = bureauId * 1
              this.columnsS[0].title = '班级'
            } else {
              this.columnsS[0].title = '学校名称'
            }
          }
        }
        axios({
          url,
          params,
          loading: false
        })
          .then(res => {
            this.loading = false
            let pageObj = {}
            if (res.status) {
              let d = res.data
              pageObj = {
                current: pageIndex,
                total: d.total
              }
              d.list.forEach(item => {
                item.courseGroupData.forEach((ele, index) => {
                  ele.forEach((val, i) => {
                    item[`courseGroupData${index}${i}`] = val
                  })
                })
              })
              // if (this.columns.length <= 2) {
              this.columns = []
              let columns2 = []
              d.courseFieldList.forEach((item, index) => {
                let obj = {
                  title: '', //d.courseList[index]
                  children: []
                }
                if (item.length == 1 && d.courseFieldList.length < 3) {
                  obj = {
                    title: `${d.courseList[index]}${item[0]}`,
                    dataIndex: `courseGroupData${index}${0}`,
                    key: `courseGroupData${index}${0}`,
                    align: 'center'
                  }
                } else {
                  item.forEach((ele, i) => {
                    obj.title = `${d.courseList[index]}`
                    obj.children.push({
                      title: ele,
                      dataIndex: `courseGroupData${index}${i}`,
                      key: `courseGroupData${index}${i}`,
                      align: 'center',
                      width: 100
                    })
                  })
                }

                columns2.push(obj)
              })
              const firstColumns = getCol(url) || this.columnsS
              this.columns = [...firstColumns, ...columns2]
              // }
              this.data = d.list
            } else {
              this.data = []
              pageObj = {
                current: 1,
                total: 0
              }
            }
            this.pagination = {
              ...this.pagination,
              ...pageObj
            }
          })
          .catch(() => {
            setTimeout(() => {
              this.loading = false
            }, 200)
          })
      },
      importTo() {
        let {
          meId,
          seId,
          dId,
          classId,
          examIsActive = 1,
          campusId,
          bureauId
        } = this.$route.query
        let unionUrl = [
          'reportnewexportstudenttranscript',
          'reportnewexportstudenttranscriptUnion',
          'reportnewexportstudenttranscriptUnion'
        ]

        let union =
          this.id == 'studentcontrast'
            ? 'exportstudenttranscriptcontrast'
            : unionUrl[examIsActive]
        let api = ApiXy.defaulteApi.path[union]

        let queryParams = {
          meId,
          seId,
          dId,
          classId,
          campusId
        }

        // 校级联考
        if (examIsActive * 1 == 2) {
          queryParams.bureauId = bureauId * 1
        }
        if (examIsActive * 1) {
          queryParams.isUnion = 1
        }
        let queryList = []
        for (let q in queryParams) {
          if (queryParams[q] !== undefined) {
            queryList.push(`${q}=${queryParams[q]}`)
          }
        }
        let url =
          `${ApiXy.defaulteApi.host}${api}?transcriptType=2&` +
          queryList.join('&') +
          '&X-ZYLX-TOKEN=' +
          getCookie('X-ZYLX-TOKEN')

        window.open(url, '_blank', '')
      }
    }
  }
</script>
<style lang="less" scoped>
  /deep/.toolTip {
    height: 32px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 6px 0px 20px 0px rgba(34, 87, 188, 0.1);
    border-radius: @border-radius-base;
    margin: 2px 0;
    padding: 0 8px;
    line-height: 32px;
  }
  .score {
    height: 100%;
    .top_div {
      min-height: 400px;
      margin-bottom: @padding-sm;
    }
    .echarts_list {
      width: 100%;
      height: 400px;
    }
    .table_div {
      height: calc(100% - 50px);
      min-height: 400px;
      // display: flex;
      // flex-direction: column;
      // padding: 20px 0;
    }
    .not_data_box {
      padding: 20px 0;
    }
  }
  // .not_div {
  // height: 400px;
  // }
</style>
